<template>
  <div>
    <div class="">
      <div
        v-if="
          cardDetails.file || (cardDetails.emails && cardDetails.emails.length)
        "
      >
        <div class="margin-top-1">
          <p class="card-info">
            <strong
              >Gift cards will be emailed to recipients with the following
              message or edit to customize message and then send.</strong
            >
          </p>
          <div class="form-holder textarea margin-top-2 items-start">
            <div class="form-label">
              <p><strong>Email Message</strong></p>
            </div>
            <div class="form-input textarea-input">
              <div class="form-input-value input-value">
                <textarea
                  v-model="emailMessage"
                  name=""
                  id=""
                  rows="8"
                  placeholder=""
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div>
          <p class="card-info">
            <strong>Enter the number of gift cards to be created.</strong>
          </p>
          <div class="form-holder margin-top-2">
            <div class="form-label">
              <p><strong>No. of cards</strong></p>
              <span>Required</span>
            </div>
            <div class="form-input form-input-value">
              <div class="form-input-value input-value">
                <input
                  type="number"
                  placeholder="Enter value"
                  v-model="noOfCards"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="cta margin-top-3  margin-bottom-1 flex justify-end gap-3"
        v-if="cardDetails.file || cardDetails.emails.length"
      >
        <div
          class="btn-save"
          v-if="cardDetails.file || cardDetails.emails.length"
        >
          <button
            @click="skipMessage"
            :disabled="creatingGiftCard"
            class="whitebutton-gemnote -gemnote button-gemnote--small"
          >
            <span>Skip </span>
          </button>
        </div>
        <div
          class="btn-save"
          v-if="cardDetails.file || cardDetails.emails.length"
        >
          <button
            @click="isModalActive = !isModalActive"
            :disabled="creatingGiftCard"
            class="button-gemnote button-gemnote--small"
          >
            <span>Send </span>
          </button>
        </div>
      </div>
      <div
        class="cta margin-top-3  margin-bottom-1 flex justify-end gap-3"
        v-else
      >
        <div class="btn-save">
          <button
            @click="onCreateGiftCard"
            :disabled="creatingGiftCard"
            class="button-gemnote button-gemnote--small"
          >
            <span>Create </span>
          </button>
        </div>
      </div>
    </div>
    <!-- GiftModal -->
    <GiftModal
      :showFooter="true"
      v-show="isModalActive"
      @hideModal="isModalActive = false"
      :showCancelButton="true"
      modalName="ConfirmGiftCModal"
      buttonLabel="Confirm"
      colorVariation="coast"
      @confirmAction="onCreateGiftCard()"
    >
      <template slot="header">
        <span>Send Gift Cards</span>
      </template>
      <template slot="body">
        <div>
          Are you sure you want to send a gift card of value
          <strong>{{ cardDetails.value }}</strong> expiring on
          <strong>{{ cardDetails.expirationDate }}</strong> to
          <strong>{{
            cardDetails.file ? emailCount : cardDetails.emails.length
          }}</strong>
          recipients? If yes, please select Confirm. Note once confirmed, this
          action cannot be undone.
        </div>
      </template>
    </GiftModal>
    <!-- GiftModal -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import i18n from '@/internatinalization/i18n'
export default {
  name: 'EcommerceGiftCardCreate',
  props: {
    cardDetails: {
      type: Object,
      // required: true,
      default: () => ({
        emails: []
      })
    },
    emailCount: {}
  },
  data() {
    return {
      isModalActive: false,
      skipSending: false,
      emailMessage:
        "Hey there,\nHere's a gift card for you to use on our store. Click the link below to browse the products available to you. Enjoy!",
      noOfCards: null,
      selectedMode: ''
    }
  },
  components: {
    GiftModal: () => import('@/components/Universal/ExportModal')
  },

  computed: {
    ...mapState({
      creatingGiftCard: state => state.ecommerce.creatingGiftCard
    })
  },
  watch: {
    cardDetails: {
      handler(newVal, oldVal) {
        if (newVal.file || (newVal.emails && newVal.emails.length)) {
          this.selectedMode = 'message'
        } else {
          this.selectedMode = 'noOfCards'
        }
      },
      deep: true // This will enable deep watching
    }
  },

  methods: {
    skipMessage() {
      this.skipSending = true
      this.onCreateGiftCard()
    },
    sendGiftCard(e, sendCard) {
      this.isModalActive = false
      this.$router.push({ name: 'EcommerceGiftCards' })

      if (sendCard) {
        this.$store.dispatch('notification/pushNotification', {
          type: 'success',
          messages: [i18n.t('ecommerce.action.gitfcards-sent-success')]
        })
      }
    },
    onCreateGiftCard() {
      if (
        (!Number(this.noOfCards) || Number(this.noOfCards) < 1) &&
        this.selectedMode === 'noOfCards'
      ) {
        this.$store.dispatch('notification/pushNotification', {
          type: 'warning',
          messages: ['Enter valid number of gift cards to be created.']
        })
        return
      }
      let formData = new FormData()
      formData.append('gift_card[description]', this.cardDetails.name)

      if (!this.skipSending && this.emailMessage) {
        formData.append('gift_card[email_message]', this.emailMessage)
      }

      if (this.noOfCards) {
        formData.append('gift_card[count]', this.noOfCards)
      }

      formData.append(
        'gift_card[amount]',
        parseFloat(this.cardDetails.value.slice(1).replace(',', ''))
      )
      formData.append(
        'gift_card[restrict_to_email]',
        this.cardDetails.restrictEmails
      )
      this.cardDetails.file
        ? formData.append('gift_card[upload_file]', this.cardDetails.file)
        : null
      this.cardDetails.expirationDate
        ? formData.append(
            'gift_card[expiration_date]',
            this.cardDetails.expirationDate
          )
        : null
      if (this.cardDetails.emails.length) {
        for (let index = 0; index < this.cardDetails.emails.length; index++) {
          const email = this.cardDetails.emails[index]
          formData.append('gift_card[emails_list][]', email)
        }
      }
      this.$store.dispatch('ecommerce/createGiftCards', formData)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.justify-end {
  justify-content: end !important;
}

.trending-container {
  padding: 1.25rem;
  border: 1px solid $main-6;
  border-radius: 2px;
  margin-bottom: 2rem;
}

.trending-header {
  h4 {
    text-align: left;
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
  }
}

h4 {
  font-family: $editorial;
  font-weight: normal;
}

.card-header {
  .editorial {
    font-size: 1.25rem;
  }

  p {
    font-size: 0.838rem;
  }
}

.card-info {
  text-align: left;
  font-size: 0.838rem;
}

.form-holder {
  display: flex;
  justify-content: space-between;
  align-items: baseline;

  &.textarea {
    align-items: flex-start;

    .form-label {
      width: 20%;
    }
  }

  .form-label {
    width: 15%;
    display: flex;
    flex-direction: column;
    text-align: left;

    p {
      font-size: 0.838rem;
    }

    span {
      font-size: 0.708rem;
      color: rgba(35, 34, 32, 0.5);
    }
  }

  .form-input {
    width: 85%;

    .upload-option-holder {
      &.muted {
        .option-text,
        .option-desc {
          color: #a09c95;
        }
      }

      .option-text {
        display: block;
        margin: 1rem 0;
        text-align: left;
        padding: 0px 5rem;
      }

      .upload-button-holder {
        display: flex;
        align-items: center;
        gap: 1rem;

        .option-desc {
          font-size: 0.773rem;
          font-weight: normal;
        }
      }
    }

    .input-value {
      width: 22%;
    }

    &.textarea-input {
      width: 100%;

      .input-value {
        width: 80% !important;
      }
    }

    input {
      font-weight: 400 !important;
      height: max-content;
    }

    .custom-date-input {
      gap: 0.3rem;
      width: 20%;

      input {
        font-weight: 400 !important;
        height: max-content;
      }

      .divider {
        font-weight: 400;
        color: #232220;
        font-size: 0.9rem;
      }
    }

    .file-details {
      align-items: flex-start;

      .file-name-holder {
        gap: 0.6rem;
        align-items: center;
        font-weight: 600;

        p {
          font-size: 0.838rem;
        }

        button {
          font-size: 0.838rem;
        }
      }

      .file-count {
        font-size: 0.708rem;
        color: #232220;
      }
    }
  }
}

.textarea-input {
  textarea {
    background-color: transparent;
    border: 1px solid #9b9b9b;
    outline: none !important;
    width: 100%;
    padding: 8px;
    font-size: 0.838rem;

    &:focus {
      border: 1px solid #9b9b9b;
    }
  }
}

.restrict-cards {
  p {
    font-size: 0.838rem;
  }
}

.allow-domains .vue-input-tag-wrapper {
  min-width: 40%;
  max-width: max-content;
}

.cta {
  text-align: right;

  &.top-spacing {
    margin-top: 7rem;
  }

  .button-gemnote--small {
    width: auto !important;
    padding: 0 1.5rem;
    height: 2.5rem;
    display: flex;
    margin-left: auto;
    gap: 20px;

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      background: #a09c95;
      color: #f5f2ee;
      border: none;
    }
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

@media (max-width: 425px) {
  .form-holder .form-label {
    width: 30%;
  }

  .form-holder .form-input .upload-option-holder .upload-button-holder {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
}
</style>
